import { RouletteScene } from '../scenes/RouletteScene';
import { BetManager } from '../ui/BetManager';
import { ChipManager } from '../ui/ChipManager';

// Função para desfazer a última aposta feita com efeito de giro
export function undoLastBet(scene: RouletteScene, betManager: BetManager, chipManager: ChipManager) {
	const lastAction = scene.history.pop();
	if (!lastAction) return;

	const { numberArea, valuesBefore, balanceBefore, betBefore, betsSnapshotBefore } = lastAction;

	const placedChip = scene.placedChipsMap.get(numberArea);
	if (!placedChip) return;

	if (valuesBefore.length === 0) {
		placedChip.destroy();
		scene.placedChipsMap.delete(numberArea);
	} else {
		const totalValue = valuesBefore.reduce((sum, v) => sum + v, 0);
		placedChip.setData('value', totalValue);
		placedChip.setData('quantity', valuesBefore.length);
		chipManager.redrawChips(placedChip);
	}

	// Reverter valores
	scene.rouletteBalanceValue = balanceBefore;
	scene.rouletteBetValue = betBefore;
	scene.rouletteBalance.setText(`Balance: ${balanceBefore}`);
	scene.rouletteBet.setText(`Bet: ${betBefore}`);

	betManager.setBetsSnapshot(betsSnapshotBefore);

	console.log(`Aposta desfeita: ficha de número ${numberArea} removida`);
}
